import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { WsUiModule } from "@web/util/ws-ui/ws-ui.module";
import { ClientContactAutocompleteOptionComponent } from "./client-contact-autocomplete-option.component";

@NgModule({
  imports: [CommonModule, TranslateModule, WsUiModule],
  declarations: [ClientContactAutocompleteOptionComponent],
  exports: [ClientContactAutocompleteOptionComponent],
})
export class ClientContactAutocompleteOptionModule {}
